import React, { useContext } from 'react';
import './videoPlayer.scss';

// CONTEXT
import { videoPlayerContext } from '../../../contexts/helpers/videoPlayer/videoPlayerContext';

const TOUR_VIDEO_ID = '-kcQ9jh4Yy4';
const TOUR_VIDEO_URL = `https://www.youtube.com/watch?v=${TOUR_VIDEO_ID}`;

const VideoPlayer = () => {

    const VideoPlayerContext = useContext(videoPlayerContext);
    const { active } = VideoPlayerContext;

    return (
        active
            ?
            <div className="video-player-wrapper">
                <a
                    className="virtual-tour-link"
                    href={TOUR_VIDEO_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Ver el Tour Virtual de Secundaria Babeque en YouTube"
                >
                    <img
                        src={`https://i.ytimg.com/vi/${TOUR_VIDEO_ID}/maxresdefault.jpg`}
                        alt="Vista previa del Tour Virtual de Secundaria Babeque"
                    />
                    <span className="virtual-tour-overlay" aria-hidden="true">
                        <span className="virtual-tour-kicker">Conoce nuestra institución</span>
                        <strong>Tour Virtual</strong>
                        <span className="virtual-tour-play">
                            <span className="virtual-tour-play-icon" />
                            Ver recorrido en YouTube
                        </span>
                    </span>
                </a>
            </div>
            : null
    )
}

export default VideoPlayer;
